<template>
	<div class="flex flex-col gap-1">
		<p class="flex">
			<span
				:class="[
					size === 'medium'
						? 'text-lg'
						: size === 'big'
							? 'text-3xl'
							: 'text-sm font-normal',
					isDiscountedProduct() ? 'font-medium text-redcustom' : 'text-price'
				]"
			>
				{{ formattedPrice }}
			</span>
			<span
				v-if="isDiscountedProduct()"
				:class="[
					'pl-4 line-through text-gray-super-dark',
					size === 'medium'
						? 'text-lg'
						: size === 'big'
							? 'text-3xl'
							: 'text-sm font-normal'
				]"
			>
				{{ formattedOldPrice }}
			</span>
		</p>
		<p
			v-if="oldPrice && isDiscountedProduct() && showSaveText"
			class="text-xs text-redcustom"
		>
			{{ $t("Save") }} {{ formatPriceWithSymbol(oldPrice - price) }} ({{
				percent
			}}%)
		</p>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { currencyMap } from "@/utils/currencyConfig";

interface Props {
	price: number;
	oldPrice?: number | null;
	size?: string;
	showSaveText?: boolean;
	showPrevious?: boolean;
	additionalText?: string;
}

const {
	size,
	oldPrice,
	price,
	showSaveText,
	additionalText = ""
} = defineProps<Props>();

const norceStore = useNorceStore();
const { formatAmount } = useFormatPrice({ groupThousands: true });

const currencySettings = computed(() => {
	const currencyCode = norceStore?.currentCurrency?.Code;
	return (
		currencyMap[currencyCode] || { symbol: currencyCode, position: "prefix" }
	);
});

const formatPriceWithSymbol = (price: number) => {
	const { symbol, position } = currencySettings.value;
	const formattedPrice = formatAmount(price);
	return position === "prefix"
		? `${symbol} ${formattedPrice}`
		: `${formattedPrice} ${symbol}${additionalText}`;
};

const formattedPrice = computed(() => formatPriceWithSymbol(price));
const formattedOldPrice = computed(() =>
	oldPrice ? formatPriceWithSymbol(oldPrice) : ""
);

const percent = computed(() => {
	if (oldPrice && price) {
		const discount = Math.floor(((oldPrice - price) / oldPrice) * 100);

		if (discount) {
			return `-${discount}`;
		}
		return 0;
	}
	return null;
});

const isDiscountedProduct = () => oldPrice && oldPrice > price;
</script>
